import {CSSObject, styled} from "@mui/material/styles"
import Link, {LinkProps} from "@mui/material/Link"
import merge from "lodash/merge"
import {LinkStyles} from "./models"
import {removeUnsetProps} from "../utils"

export const StyledLink = styled(Link, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<LinkProps & {$linkStyles: LinkStyles | undefined}>(({$linkStyles}) => {
    const override = removeUnsetProps({
        color: $linkStyles?.linkColor,
        textDecoration: $linkStyles?.linkUnderline,
        fontWeight: $linkStyles?.linkWeight,
        "&:hover": {
            color: $linkStyles?.linkHoverColor,
        },
    } as CSSObject)
    return merge(
        {
            textDecoration: "underline",
            color: "inherit",
        },
        override,
    )
})
